import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public cdnBase = '';
  public gaTrackingCode: string| object = '';
  public gaEnabled = false;
  public apiBase = '/';
  public authToken = '';

  public pendoEnabled = false;
  public pendoApiKey = '';

  constructor() { }
}
